/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Style_Paint_OnInputs */

const en_caption_style_paint_on = /** @type {(inputs: Caption_Style_Paint_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paint-On`)
};

const fr_caption_style_paint_on = /** @type {(inputs: Caption_Style_Paint_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paint-On`)
};

const de_caption_style_paint_on = /** @type {(inputs: Caption_Style_Paint_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufmalen`)
};

const it_caption_style_paint_on = /** @type {(inputs: Caption_Style_Paint_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dipingere`)
};

const ru_caption_style_paint_on = /** @type {(inputs: Caption_Style_Paint_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наносить краской`)
};

const es_caption_style_paint_on = /** @type {(inputs: Caption_Style_Paint_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pintar sobre`)
};

const zh_cn2_caption_style_paint_on = /** @type {(inputs: Caption_Style_Paint_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`涂漆`)
};

const ja_caption_style_paint_on = /** @type {(inputs: Caption_Style_Paint_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ペイントオン`)
};

const hi_caption_style_paint_on = /** @type {(inputs: Caption_Style_Paint_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पर पैंट`)
};

const pt_pt2_caption_style_paint_on = /** @type {(inputs: Caption_Style_Paint_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pintar`)
};

/**
* | output |
* | --- |
* | "Paint-On" |
*
* @param {Caption_Style_Paint_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_style_paint_on = /** @type {((inputs?: Caption_Style_Paint_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Style_Paint_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_caption_style_paint_on(inputs)
	if (locale === "de") return de_caption_style_paint_on(inputs)
	if (locale === "it") return it_caption_style_paint_on(inputs)
	if (locale === "ru") return ru_caption_style_paint_on(inputs)
	if (locale === "es") return es_caption_style_paint_on(inputs)
	if (locale === "zh-CN") return zh_cn2_caption_style_paint_on(inputs)
	if (locale === "ja") return ja_caption_style_paint_on(inputs)
	if (locale === "hi") return hi_caption_style_paint_on(inputs)
	if (locale === "pt-PT") return pt_pt2_caption_style_paint_on(inputs)
	return en_caption_style_paint_on(inputs)
});